import { FONT_STYLES } from '@/styles/fonts'

export default function Footer() {
  return (
    <footer className="w-full bg-gray-900 text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4 tracking-wide" style={FONT_STYLES.alga}>About</h3>
            <p className="text-gray-400 tracking-wide" style={FONT_STYLES.alga}>
              Your intelligent travel planning assistant
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4 tracking-wide" style={FONT_STYLES.alga}>Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#" className="hover:text-white tracking-wide" style={FONT_STYLES.alga}>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-white tracking-wide" style={FONT_STYLES.alga}>
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4 tracking-wide" style={FONT_STYLES.alga}>Contact</h3>
            <p className="text-gray-400 tracking-wide" style={FONT_STYLES.alga}>support@carmen.com</p>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p className="tracking-wide" style={FONT_STYLES.alga}>&copy; {new Date().getFullYear()} Yunacaba Carmen. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

